import ChargingStationStore from "./ChargingStationStore";
import ChargingStationTableContainer from "./ChargingStationTableContainer";
export default ChargingStationStore(ChargingStationTableContainer);